import React from 'react';
import { Instagram } from 'lucide-react';

const SocialMedia = () => {
  // Showcase images from actual work
  const showcaseImages = [
    { src: '/images/before-after/window-cleaning.jpg', alt: 'Window Cleaning' },
    { src: '/images/before-after/house-wash-1.jpg', alt: 'House Washing' },
    { src: '/images/before-after/deck-wash.jpg', alt: 'Deck Washing' },
    { src: '/images/before-after/gutter-cleaning.jpg', alt: 'Gutter Cleaning' },
    { src: '/images/shrink-wrap/shrink-wrap-new.jpg', alt: 'Shrink Wrapping' },
    { src: '/images/before-after/house-wash-2.jpg', alt: 'House Washing Results' },
    { src: '/images/services/gutter-cleaning.jpg', alt: 'Professional Gutter Service' },
    { src: '/images/hero/hero-background.jpg', alt: 'Professional Cleaning' },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
          Follow Us On Social Media
        </h2>
        <p className="text-xl text-gray-600 mb-12">
          See our latest work and happy customers
        </p>

        <a
          href="https://www.instagram.com/reflectionscleaningsny"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          data-testid="instagram-link"
        >
          <Instagram className="w-7 h-7" />
          @reflectionscleaningsny
        </a>

        {/* Instagram-style Grid with Real Images */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {showcaseImages.map((image, index) => (
            <a
              key={index}
              href="https://www.instagram.com/reflectionscleaningsny"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300"
              data-testid={`instagram-image-${index}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <Instagram className="w-10 h-10 text-white" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;
